module.exports = __webpack_public_path__ + "5b3456fed4684dbdf59f6384e32fb7f8.jpg";